import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import Item from '../../../Item';
import { ProfileIcons } from '../../../Icons';
import { AGENT_CONNECTION_STATUSES } from 'settings/constants/common';
import Input from 'components/Form/Input';
import { showErrorMessage } from 'helpers/errors';
import { updateClientDataEffect } from 'store/effects';
import { showSuccessMessage } from 'helpers';

import styles from './styles.module.scss';
import { getAgentTypeSelector, getUserId } from 'store/selectors/user';
import { AGENT_TYPE } from 'settings/constants/drawers';
import { TEAM_ADMIN, TEAM_BASIC, TEAM_OWNER } from 'settings/constants/roles';
import { validateEmail } from 'utils';

export const Email = ({ contact, isExpanded }) => {
  const [emailEdit, setEmailEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(contact.Email);
  const isPendingClient = contact?.Client?.InvitationStatus === AGENT_CONNECTION_STATUSES.PENDING;

  const agentType = useSelector(getAgentTypeSelector);
  const dispatch = useDispatch();
  const userId = useSelector(getUserId);
  const isClient = useMemo(() => contact.Client?.Id, [contact]);

  const isItemEditable = useMemo(() => {
    if (isClient) {
      return isExpanded;
    }
    return false;
  }, [isClient]);

  const onSubmit = () => {
    if (contact.Email !== email) {
      if (validateEmail(email)) {
        setLoading(true);
        dispatch(
          updateClientDataEffect({ clientId: contact.Id, email: email?.toLowerCase() }, (err) => {
            if (!err) {
              showSuccessMessage('Client email updated');
            }
            setLoading(false);
            setEmailEdit(false);
          }),
        );
      } else {
        showErrorMessage('Invalid email');
      }
    }
  };

  const getEmailValue = () => {
    const emailValue = (
      <a
        className={classNames(styles.email, { [styles.defaultCursor]: !isItemEditable })}
        href={`mailto:${contact.Email}`}
      >
        {contact.Email}
      </a>
    );

    if (emailEdit) {
      return (
        <Input
          id="email"
          className={styles.editEmail}
          inputHolderClassName={styles.inputHolder}
          type="text"
          value={email}
          onChange={(e, val) => setEmail(val)}
          onBlur={onSubmit}
          icon={
            <div className={styles.close} onClick={() => setEmailEdit(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path d="M17 17L7 7" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
                <path d="M7 17L17 7" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
          }
          disabled={loading}
        />
      );
    }
    // replace with isPendingClient if we only want to allow editing for pending clients
    return isItemEditable ? (
      <div className={styles.emailContainer}>
        <div className={styles.editIcon} onClick={() => setEmailEdit(true)}>
          <ProfileIcons name={ProfileIcons.EDIT} />
        </div>
        {emailValue}
      </div>
    ) : (
      emailValue
    );
  };

  return (
    <Item
      className={classNames(styles.emailItem, {
        [styles.expanded]: isExpanded,
      })}
      testid="email"
      label="Email"
      value={getEmailValue()}
    />
  );
};
